import React from 'react';
import PropTypes from 'prop-types';

export const JobDescription = (props) => {

        const { job } = props;
        return (
            <div className="job-description">
                <p dangerouslySetInnerHTML={ {__html: job.description } } ></p>
            </div>
        );
}

JobDescription.propTypes = {
    job: PropTypes.object
}



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobDescription.js